export const COLOR = {
  white: '#FFFFFF',
  lightGray: '#F0F0F0',
};
